import { render } from "./DanhSachVeKhongSoDo.vue?vue&type=template&id=c4eb4b82&scoped=true"
import script from "./DanhSachVeKhongSoDo.vue?vue&type=script&lang=js"
export * from "./DanhSachVeKhongSoDo.vue?vue&type=script&lang=js"

import "./DanhSachVeKhongSoDo.vue?vue&type=style&index=0&id=c4eb4b82&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4eb4b82"]])

export default __exports__